import ReactGA from "react-ga4";

export const capturepageanalytics = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

export const captureeventbaseanalytics = (category, action, label) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
};
